
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLocation } from 'react-router-dom';
import { NavbarActions } from './navbar/NavbarActions';
import { getPageTitle } from './utils/pageUtils';
import { useDynamicPageTitle } from './utils/dynamicPageTitle';

type NavbarProps = {
  onMenuClick?: () => void;
  isMobile?: boolean;
  onToggleSidebar?: () => void;
};

const Navbar = ({ onMenuClick, isMobile = false }: NavbarProps) => {
  const location = useLocation();
  const dynamicTitle = useDynamicPageTitle();
  const pageTitle = dynamicTitle || getPageTitle(location.pathname);

  return (
    <header className="h-16 border-b border-border bg-white/80 backdrop-blur-sm dark:bg-background/80 sticky top-0 z-20 px-4 md:px-6 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0 flex-1">
        {isMobile && (
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden shrink-0"
            onClick={onMenuClick}
            aria-label="Menu"
            type="button"
          >
            <Menu size={20} />
          </Button>
        )}
        <h1
          className="text-lg md:text-2xl font-medium text-foreground truncate"
          title={pageTitle}
        >
          {pageTitle}
        </h1>
      </div>

      <div className="shrink-0">
        <NavbarActions />
      </div>
    </header>
  );
};

export default Navbar;
